<div class="wrapper-page-single-blog">
  <div class="zc-container">
    <div class="grid">
      <div class="grid__s-12">
        <div [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" class="wrapper-back-to-page">
          <img src="../../../../../assets/icons/landing/icon-arrow-back-page.png" alt="">
          <span>Nazad na blog</span>
        </div>
      </div>
    </div>
  </div>
  <!--  Content blog   -->
  <div *ngIf="blog" class="zc-container content-single-blog">
    <div class="grid">
      <div class="grid__s-12">
        <div class="wrapper-cover-image-blog">
          <img [src]="blog.image.full_path" alt="">
        </div>
      </div>
      <div class="grid__s-12">
        <div class="wrapper-info-blog">
          <div class="zc-d-flex zc-align-items">
            <div class="wrapper-category-label" [ngClass]="blog.category | lowercase">
              <span>{{ blog.category }}</span>
            </div>
            <span class="label-blog-info">{{ blog.created_at | timeAgo }}</span>
          </div>
          <span class="label-blog-info name">{{blog.author_name}}</span>
        </div>
      </div>
      <div class="grid__s-12">
        <div class="wrapper-content-single-blog">
          <h1>{{blog.title}}</h1>
          <p [innerHTML]="blog.intro_text"></p>
          <div *ngFor="let section of blog.sections">
            <h2 *ngIf="section.type === BlogSectionType.heading">{{section.value}}</h2>
            <p *ngIf="section.type === BlogSectionType.text" [innerHTML]="section.value"></p>
            <img *ngIf="section.type === BlogSectionType.image" [src]="section.media.full_url"  alt=""/>
            <video
              *ngIf="section.type === BlogSectionType.video"
              width="100%"
              height="auto"
              controls
              preload="metadata"
              [src]="section.media.full_url"
              type="video/mp4"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="blog?.related_blogs?.length" class="zc-container">
    <div class="wrapper-landing-blogs">
      <div class="grid">
        <div class="grid__s-12">
          <span class="small-title">Povezane vesti</span>
        </div>
      </div>
      <div  class="grid">
        <div *ngFor="let blog of blog?.related_blogs" class="grid__m-4">
          <div class="wrapper-card-blog">
            <div class="wrapper-header-card-blog">
              <img [src]="blog.image.full_path" alt="">
            </div>
            <div class="wrapper-content-card-blog">
              <div class="zc-d-flex zc-align-items">
                <div class="wrapper-category-label" [ngClass]="blog.category | lowercase">
                  <span>{{ blog.category }}</span>
                </div>
                <span class="time-card-blog">{{ blog.created_at | timeAgo }}</span>
              </div>
              <span class="title-landing-blog-card length-character-column length-character-column--2">{{ blog.title }}</span>
              <span class="subtitle-landing-blog-card length-character-column length-character-column--2" [innerHTML]="blog.intro_text"></span>
              <span class="link-blue-text" [routerLink]="[PAGES_AND_PATHS.landingSingleBlog.pagePath, blog.id]">Pročitaj...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
